module.exports = __webpack_public_path__ + "static/logo-foot-834db44f2a7a8edf7e2a3eeab11fef66.svg";